import { render, staticRenderFns } from "./tutor_layout.vue?vue&type=template&id=b0bc9f76&scoped=true&"
import script from "./tutor_layout.vue?vue&type=script&lang=js&"
export * from "./tutor_layout.vue?vue&type=script&lang=js&"
import style0 from "./tutor_layout.vue?vue&type=style&index=0&id=b0bc9f76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0bc9f76",
  null
  
)

export default component.exports